import { memo } from 'react';
import cls from 'classnames';

import styles from './Separator.module.css';

interface SeparatorProps {
  className?: string;
}

function Separator({ className }: SeparatorProps) {
  return <hr className={cls(styles.separator, className)} />;
}

export default memo(Separator);
